import type { FlagKey, LoggerDamagedFlagResponse } from '../types/Flag';
import type { LoggerId } from '../types/Logger';
import { client } from './Client';

export const getDamagedFlagsByLoggerId = async (loggerId: LoggerId) => {
    return client
        .get<LoggerDamagedFlagResponse>('/devices/flags/damaged', {
            params: {
                loggerIds: loggerId
            }
        })
        .then((response) => response.data);
};

export const flagLoggerAsDamaged = async (loggerId: LoggerId, flags: Array<FlagKey>) => {
    return client
        .patch('/devices/flags', {
            deviceIds: [loggerId],
            add: flags
        })
        .then((response) => response.data);
};
